// extracted by mini-css-extract-plugin
export default {"button":"AsttButtonDark_button__JZwuL"};